import React, {Component} from 'react';
import Chart from "chart.js";
import Api from "../../../libraries/api";
import {CircularProgress} from "@material-ui/core";

class ChartFulfillment extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.state = {
            period: 'weekly',
            loading: false
        };
        this.getFulfillmentChart('weekly')
        this.handleChange = this.handleChange.bind(this);
        this.getFulfillmentChart = this.getFulfillmentChart.bind(this);
    }

    getFulfillmentChart(period) {
        Api.get('/reports/order-status?period=' + period, true).then(resp => {
            if (resp.data) {
                let labels = resp.data["orderStatus"]["columns"];
                let ordered = resp.data["orderStatus"]["ordered"];
                let shippied = resp.data["orderStatus"]["shipped"];
                let delivered = resp.data["orderStatus"]["delivered"];
                this.setState({loading: false})
                this.__chart(labels, ordered, shippied, delivered)
            }
        }).catch(err => {
            console.log(err);
        });
    }

    __chart = (labels, ordered, shipped, delivered) => {
        var barChartData = {
            labels: labels,
            datasets: [{
                label: 'Ordered',
                backgroundColor: '#008299',
                borderColor: '#008299',
                borderWidth: 1,
                hiddenLegend: true,
                datalabels: {
                    color: 'transparent'
                },
                data: ordered
            }, {
                label: 'Shipped',
                backgroundColor: '#10d7ee',
                borderColor: '#10d7ee',
                borderWidth: 1,
                hiddenLegend: true,
                datalabels: {
                    color: 'transparent'
                },
                data: shipped
            }, {
                label: 'Delivered',
                backgroundColor: '#1846b0',
                borderColor: '#1846b0',
                borderWidth: 1,
                hiddenLegend: true,
                datalabels: {
                    color: 'transparent'
                },
                data: delivered
            }]
        };
        let myChartRef = this.chartRef.current.getContext("2d");
        new Chart(myChartRef, {
            type: 'bar',
            data: barChartData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                legend: {
                    position: 'top',
                },
            }
        }).update();
    }

    handleChange = (target, prop) => {
        this.setState({period: target, loading: true}, () => {
            this.getFulfillmentChart(target)
        });
    };

    render() {
        return (
            <div>
                <div className="row" style={{marginTop:'26px'}}>
                    <div className="card col-md-12 col-lg-12" style={{padding:'20px 20px 0px 20px'}}>
                        <div className="row title-dashboard">
                            <div className="col-6">
                                <h2>Fulfillment</h2>
                            </div>
                        </div>
                        <div className="d-md-flex justify-content-center mt-4 mb-4">
                            <nav className="nav nav-filter">
                                <button className={"nav-link pl-0 " + (this.state.period === 'daily' && 'active')}
                                        onClick={() => this.handleChange('daily', 'period')}>Daily
                                </button>
                                <button className={"nav-link " + (this.state.period === 'weekly' && 'active')}
                                        onClick={() => this.handleChange('weekly', 'period')}>Weekly
                                </button>
                                <button className={"nav-link " + (this.state.period === 'monthly' && 'active')}
                                        onClick={() => this.handleChange('monthly', 'period')}>Monthly
                                </button>
                            </nav>
                        </div>
                        <ShowFulfillmentChart loading={this.state.loading} chartRef={this.chartRef}/>
                    </div>
                </div>
            </div>
        )
    }
}

class ShowFulfillmentChart extends Component {
    render() {
        if (this.props.loading === true) {
            return <CircularProgress/>
        } else {
            return (
                <div className="chart-container">
                    <canvas id="myChart" ref={this.props.chartRef}/>
                </div>
            )
        }
    }
}


export default ChartFulfillment;